import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon, LeafIcon, ArrowUpRightIcon } from 'lucide-react';
interface QuickLink {
  label: string;
  href: string;
}
const QUICK_LINKS: QuickLink[] = [{
  label: 'Los 6 tomos',
  href: '#tomos'
}, {
  label: 'Qué incluye',
  href: '#incluye'
}, {
  label: 'Bonos',
  href: '#bonos'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}, {
  label: 'Precio y acceso',
  href: '#comprar'
}];
const LEGAL_LINKS: QuickLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Política de reembolso',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="relative overflow-hidden bg-sand" data-id="element-66" data-mp="3lggcmv2uz5fm">
      <div className="h-px w-full bg-gold/30" aria-hidden data-id="element-67" data-mp="3qc44ji8q6cot" />
      <div className="pointer-events-none absolute -bottom-28 -right-20 h-72 w-72 rounded-full bg-stone/50 blur-3xl" aria-hidden data-id="element-68" data-mp="29ynmxp3fzdg4" />

      <div className="relative mx-auto max-w-6xl px-5 py-12 sm:py-14" data-id="element-69" data-mp="2ezl5i2sd69i5">
        <div className="grid gap-8 md:grid-cols-3 md:gap-8 lg:gap-12" data-id="element-70" data-mp="3lalkbra34rzr">
          {/* Marca y producto */}
          <div className="md:col-span-1" data-id="element-71" data-mp="3gbqyeggtmnbf">
            <p className="font-display text-2xl leading-tight text-charcoal" data-id="element-72" data-mp="3v7q63q00qlg1">
              Wellness Digital <span className="text-gold-deep" data-id="element-73" data-mp="3v5dh4svufath">PRO™</span>
            </p>
            <p className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-gold/40 bg-ivory px-3 py-1 text-[0.62rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-74" data-mp="3q7bvq1ay2zeu">
              <LeafIcon className="h-3 w-3 text-gold-deep" aria-hidden data-id="element-75" data-mp="33e4b4nsygpk" />
              MegaPack 6 en 1
            </p>
            <p className="mt-4 max-w-sm text-[0.82rem] leading-relaxed text-charcoal/65" data-id="element-76" data-mp="huwgsshgdt46">
              El sistema para profesionales de Yoga, Pilates, Coaching, Meditación y Terapias de
              Argentina que quieren convertir Instagram en una herramienta para atraer alumnos y
              clientes.
            </p>
            <p className="mt-4 max-w-sm font-display text-base italic leading-snug text-charcoal/80" data-id="element-77" data-mp="tvczjrxji5f5">
              Porque dedicarte al bienestar de otros no debería costarte tu propio bienestar. 🌿
            </p>
          </div>

          {/* Enlaces rápidos */}
          <nav aria-label="Enlaces rápidos" data-id="element-78" data-mp="13rzk0flyeugn">
            <h2 className="text-[0.62rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-79" data-mp="18kiwtacthlke">
              Explorá el pack
            </h2>
            <ul className="mt-4 space-y-2" data-id="element-80" data-mp="1clckq3q9f0da">
              {QUICK_LINKS.map(link => <li key={link.label} data-id="element-81" data-mp="1hj4cmxqwmmhh">
                  <a href={link.href} className="group inline-flex items-center gap-1.5 text-[0.82rem] text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-82" data-mp="1mjsb24hgq5lq">
                    {link.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5 text-gold/60 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold-deep" aria-hidden data-id="element-83" data-mp="3tb18nwmogii1" />
                  </a>
                </li>)}
            </ul>
          </nav>

          {/* Soporte */}
          <div data-id="element-84" data-mp="1wo8q4vn4bioh">
            <h2 className="text-[0.62rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-85" data-mp="1worz3musiwqd">
              Soporte
            </h2>
            <ul className="mt-4 space-y-2 text-[0.82rem]" data-id="element-86" data-mp="2tbvhif5c4av2">
              <li data-id="element-87" data-mp="2pdfpfwueccas">
                <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-88" data-mp="2pcw569h9xbtl">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-89" data-mp="18zfocijtegly">
                    <MailIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-90" data-mp="2rvr9bkiumyhz" />
                  </span>
                  soporte@creativodigital.shop
                </a>
              </li>
              <li data-id="element-91" data-mp="2woanailg7vnb">
                <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-92" data-mp="2ivb7sglo21fr">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-93" data-mp="31lj3weqy7rmg">
                    <InstagramIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-94" data-mp="36juggx8mog8d" />
                  </span>
                  @creativodigitalstudio
                </a>
              </li>
              <li data-id="element-95" data-mp="1v601ykpglgur">
                <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-96" data-mp="1v6i6s5q6t3ea">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-97" data-mp="1rnswvmpq8kej">
                    <GlobeIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-98" data-mp="13z0582g50ypq" />
                  </span>
                  www.creativodigital.shop
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legales */}
        <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2 text-[0.72rem] text-charcoal/45" data-id="element-99" data-mp="18x1p2ple1229">
          {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-100" data-mp="l6p7en0cbqyh">
              <a href={link.href} className="transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-101" data-mp="l5nx4kr5f8ht">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Cierre */}
        <div className="mt-5 border-t border-stone pt-5" data-id="element-102" data-mp="2q0oxkx8w9bgr">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-103" data-mp="2q18gohaa65wd">
            <p className="text-[0.72rem] text-charcoal/50" data-id="element-104" data-mp="2uz09ddir1w1m">
              © Creativo Digital™ 2026 — Todos los derechos reservados.
            </p>
            <p className="text-[0.72rem] text-charcoal/45" data-id="element-105" data-mp="22am5wi8w67io">
              Un producto de{' '}
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="font-semibold text-gold-deep transition-colors hover:text-gold focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-106" data-mp="27a78d2n9sy05">
                Creativo Digital
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}